import { UserRole } from '@atlas/types'

// Centralized role display labels + selectable options, so the table, invite form,
// and role-edit dialog stay consistent. Role hierarchy logic itself is NOT defined
// here — it comes from the shared `roleAtLeast`/`isAdmin` helpers in @atlas/types.

/** Human-readable label for each Atlas role. */
export const ROLE_LABELS: Record<UserRole, string> = {
	[UserRole.VIEWER]: 'Viewer',
	[UserRole.USER]: 'User',
	[UserRole.ADMIN]: 'Admin',
	[UserRole.SUPER_ADMIN]: 'Super Admin',
}

/** Selectable roles in ascending-privilege order, for role `<select>` controls. */
export const ROLE_OPTIONS: ReadonlyArray<{ value: UserRole; label: string }> = [
	UserRole.VIEWER,
	UserRole.USER,
	UserRole.ADMIN,
	UserRole.SUPER_ADMIN,
].map((value) => ({ value, label: ROLE_LABELS[value] }))

/** Backend-safe default for a newly provisioned user — never a privileged role. */
export const DEFAULT_PROVISION_ROLE: UserRole = UserRole.USER

/**
 * Safe label lookup that tolerates an unexpected role string, and an absent one:
 * the directory withholds `role` below `ADMIN` (ADR-0031), so a surface that
 * renders it may legitimately receive nothing.
 */
export const roleLabel = (role: UserRole | string | undefined): string =>
	role ? (ROLE_LABELS[role as UserRole] ?? role) : '—'
